/* Superdil redesign — JS global (vanilla, fără dependențe).
 * - buton „Înapoi sus”
 * - pill-ul de coș din header (total + număr), sincronizat cu evenimentele de coș Dawn
 * - „Adaugă în coș” de pe carduri: AJAX pe /cart/add și deschide cart drawer-ul temei
 * Folosește din Dawn: subscribe/publish (pubsub.js), PUB_SUB_EVENTS (constants.js), window.routes.
 */
(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hasPubSub = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Înapoi sus ---------- */
  function initBackToTop() {
    const cfg = window.sdSettings || {};
    if (!cfg.backToTop || document.querySelector('.sd-totop')) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sd-totop';
    btn.setAttribute('aria-label', cfg.backToTopLabel || 'Înapoi sus');
    btn.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="m5.5 11.5 6.5-6.5 6.5 6.5"/></svg>';
    document.body.appendChild(btn);

    let ticking = false;
    const update = () => {
      btn.classList.toggle('is-visible', window.scrollY > 600);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
  }

  /* ---------- Pill coș ---------- */
  let pillRequest = null;
  function refreshCartPill() {
    const pills = document.querySelectorAll('[data-sd-cart-pill]');
    if (!pills.length) return Promise.resolve();
    if (pillRequest) pillRequest.abort();
    pillRequest = new AbortController();

    return fetch(`${rootUrl()}?section_id=sd-cart-pill`, { signal: pillRequest.signal })
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sd-cart-pill-inner]');
        if (!fresh) return;
        pills.forEach((pill) => {
          const inner = pill.querySelector('[data-sd-cart-pill-inner]');
          if (inner) inner.innerHTML = fresh.innerHTML;
        });
      })
      .catch(() => {});
  }

  function initCartPill() {
    if (hasPubSub()) subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartPill);
    // Revenire cu butonul „înapoi” (bfcache): coșul poate fi modificat între timp în alt tab.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshCartPill();
    });

    document.addEventListener('click', (event) => {
      const pill = event.target.closest('[data-sd-cart-pill]');
      if (!pill) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return; // fără drawer => link normal spre /cart
      event.preventDefault();
      drawer.open(pill);
    });
  }

  /* ---------- Adaugă în coș (carduri) ---------- */
  function showCardError(button, message) {
    const card = button.closest('[data-sd-card]');
    const box = card && card.querySelector('[data-sd-card-error]');
    if (!box) return;
    box.textContent = message || 'Nu am putut adăuga produsul. Încearcă din nou.';
    box.hidden = false;
    clearTimeout(box._sdTimer);
    box._sdTimer = setTimeout(() => {
      box.hidden = true;
    }, 6000);
  }

  async function addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.getAttribute('aria-busy') === 'true') return;

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const label = button.querySelector('[data-sd-add-label]');
    const originalLabel = label ? label.textContent : '';

    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Se adaugă…';

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await response.json();

      if (data.status) {
        showCardError(button, data.description || data.message);
        return;
      }
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }
      if (hasPubSub()) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sd-card', productVariantId: variantId, cartData: data });
      }
      cart.renderContents(data);
      // ca în product-form.js (Dawn): altfel focus-trap-ul drawer-ului caută conținutul „coș gol”
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    } catch (error) {
      showCardError(button);
    } finally {
      button.removeAttribute('aria-busy');
      if (label) label.textContent = originalLabel;
    }
  }

  function initAddToCart() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sd-add]');
      if (!button) return;
      event.preventDefault();
      addToCart(button);
    });
  }

  window.SdRedesign = { refreshCartPill };

  initBackToTop();
  initCartPill();
  initAddToCart();
})();
